import {
  CalendarRef,
  DefaultCalendarWrite,
  ExternalConnection,
} from '@griply/types';

// One default across all accounts, stored per connection — so picking one is also a clear on
// every other holder. Connections already carrying the right value are left out; a redundant
// write would bump updatedAt and churn the subscription for nothing.
export const getDefaultCalendarWrites = (
  connections: ExternalConnection[],
  next: CalendarRef,
): DefaultCalendarWrite[] =>
  connections.flatMap((connection) => {
    const current = connection.settings?.defaultCalendar ?? null;
    const defaultCalendar =
      connection.id === next.connectionId ? next.calendarId : null;

    if (current === defaultCalendar) {
      return [];
    }

    return [{ connectionId: connection.id, defaultCalendar }];
  });
